import React from 'react';
import { DialogContent } from '@mui/material';

import Dialog from '@/components/molecules/Dialog/Dialog';
import { analyticsEvent } from '@/src/analytic_tag_manager';
import PractitionerItem from '@/components/molecules/PractitionerItem/PractitionerItem';

const SelectDialog = (props: any) => {
  const { options, onPractitionerClick, ...rest } = props;

  const onOptionClick = (practitionerObj: any) => {
    analyticsEvent({
      category: 'Booking',
      action:
        practitionerObj.id === 'NO_PRAT_PREFER'
          ? 'SelectNoPreference'
          : 'SelectPractitioner',
    });

    onPractitionerClick(practitionerObj);
  };

  return (
    <Dialog {...rest}>
      <DialogContent>
        <ul>
          {options?.map(practitionerObj => (
            <PractitionerItem
              key={practitionerObj?.professional?.practitionerId}
              card={practitionerObj}
              handleChooseItem={() => onOptionClick(practitionerObj)}
            />
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};

export default SelectDialog;
